// extracted by mini-css-extract-plugin
export default {"resetButton":"ResetButton_resetButton__0Pg9n","active":"ResetButton_active__h+zWT"};